var _rect, _g, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    fill: "#DFE6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.2, 0.2) translate(30, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 45.670815,7.8593764 c -10.065898,0 -18.15625,8.1216026 -18.15625,18.1875006 l 0,39.03125 c 0,10.065898 8.090352,18.1875 18.15625,18.1875 10.065898,0 18.1875,-8.121602 18.1875,-18.1875 l 0,-39.03125 c 0,-10.065898 -8.121602,-18.1875006 -18.1875,-18.1875006 z m -30.0625,30.3527546 c -2.403797,0 -4.34375,2.189532 -4.34375,4.90625 l 0,21.959746 c 0.01541,9.068783 3.658361,17.929863 10.0625,24.375 3.745056,3.732199 8.297197,6.529026 13.25,8.21875 l 0,7.281243 -14.375,0 c -4.206644,0 -7.59375,3.38711 -7.59375,7.59375 l 0,7.59375 66.15625,0 0,-7.59375 c 0,-4.20664 -3.387106,-7.59375 -7.59375,-7.59375 l -14.375,0 0,-7.281243 c 4.952803,-1.689724 9.504944,-4.486551 13.25,-8.21875 6.404142,-6.445138 10.047086,-15.306214 10.0625,-24.375 l 0,-21.959746 c 0,-2.716727 -1.939953,-4.90625 -4.34375,-4.90625 -2.403796,0 -4.3125,2.189523 -4.3125,4.90625 l 0,21.959746 c 0.01541,6.707582 -2.787826,13.531557 -7.53125,18.25 -4.709682,4.747781 -11.548124,7.54741 -18.25,7.53125 -6.701876,0.01616 -13.509068,-2.783469 -18.21875,-7.53125 -4.743426,-4.718443 -7.54666,-11.542416 -7.53125,-18.25 l 0,-21.959746 c 0,-2.716718 -1.908704,-4.90625 -4.3125,-4.90625 z",
    fill: "#070A0E"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    stroke: "#DFE6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.e80cf4d625a32f9b87b00e6f3e911c0b.svg";
export { ForwardRef as ReactComponent };